"use client";

import Loading from "@/components/Loading";
import ViuGoThreeColSection from "./ViuGoThreeColSection";
import ViuGoCorrectScoresSection from "./ViuGoCorrectScoresSection";
import "./index.css";

export default function ViuGoOtherBetsDropdown({
    loadingOtherOdds,
    otherOddsData,
    hasOtherData,
    correctScoresListFull = [],
    correctScoresFull = { home: [], draw: [], away: [] },
    totalCornersOdds = [],
    odds = {},
}) {
    return (
        <div className="viugo-odt-wrapper rounded rounded-t-none border-0 p-1 shadow-none outline-none ring-0 md:px-4 md:pt-[15px] md:pb-8 min-w-0 overflow-hidden">
            {loadingOtherOdds && !otherOddsData && (
                <div className="w-full py-4">
                    <Loading />
                </div>
            )}

            {!loadingOtherOdds && otherOddsData && !hasOtherData && (
                <div className="viugo-odt-empty">Chưa có dữ liệu kèo cược khác</div>
            )}

            {!loadingOtherOdds && hasOtherData && (
                <div className="viugo-odds-detail-table">
                    <div className="flex flex-wrap gap-1 md:gap-y-[10px] md:gap-x-4">
                        <ViuGoThreeColSection
                            title="Kèo phạt góc"
                            items={[
                                {
                                    label: "Đội nhà",
                                    value: totalCornersOdds?.[0]?.over,
                                    trend: totalCornersOdds?.[0]?.initialOverTrend,
                                },
                                {
                                    label: "Đội khách",
                                    value: totalCornersOdds?.[0]?.under,
                                    trend: totalCornersOdds?.[0]?.initialUnderTrend,
                                },
                                { label: "Hòa", value: null },
                            ]}
                            width="ods-100"
                        />

                        <ViuGoThreeColSection
                            title="FT 1x2"
                            items={[
                                {
                                    label: "Đội nhà",
                                    value: odds?.homeEuropeOdds,
                                    trend: odds?.homeEuropeTrend,
                                },
                                {
                                    label: "Đội khách",
                                    value: odds?.awayEuropeOdds,
                                    trend: odds?.awayEuropeTrend,
                                },
                                {
                                    label: "Hòa",
                                    value: odds?.instantDrawOdds,
                                    trend: odds?.drawTrend,
                                },
                            ]}
                            width="ods-50"
                        />

                        <ViuGoThreeColSection
                            title="HT 1x2"
                            items={[
                                {
                                    label: "Đội nhà",
                                    value: odds?.homeHandicapHalfOdds,
                                    trend: odds?.homeHandicapHalfTrend,
                                },
                                {
                                    label: "Đội khách",
                                    value: odds?.awayHandicapHalfOdds,
                                    trend: odds?.awayHandicapHalfTrend,
                                },
                                { label: "Hòa", value: null },
                            ]}
                            width="ods-50"
                        />

                        {correctScoresListFull.length > 0 && (
                            <ViuGoCorrectScoresSection
                                title="Kèo tỷ số cả trận"
                                correctScoresFull={correctScoresFull}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

